import { Component, OnInit, Input, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router' ;
import { globalData } from 'src/app/main/Models/global.model';

import { ApiService, DialogsService } from '../../custom-material/Services/';

import { BuildingModel, DiagnosticModel, Colors } from '../../main/Models';

@Component({
  selector: 'audit-list',
  templateUrl: './t_audit-list.component.html',
  styleUrls: ['./audit-list.component.less']
})
export class AuditListComponent implements OnInit {

  @Input()
  building: BuildingModel;

  diagnostics: Array<DiagnosticModel> = [];
  showedDiagnostics: Array<DiagnosticModel> = [];

  isLoading = true;

  constructor(private dialogService: DialogsService,
              private apiService: ApiService,
              private router: Router,
              private gd: globalData,
              private snackBar: MatSnackBar) { }

  ngOnInit() {
  	this.loadDiagnostics();
  }

	loadDiagnostics()
  {
    let diagnosticMemberOf = {
      building: this.building.id,
      trash: 0
    };
    let diagnosticParams = this.apiService.createParams(diagnosticMemberOf, 'eq');

    this.isLoading = true;
    setTimeout(()=>{ this.snackBar.open('Chargement en cours') }, 0);

    this.apiService.getFromServer('diagnostic', diagnosticParams)
      .then(s => s.subscribe((response:any) => {
        for (var i = response._embedded.diagnostic.length - 1; i >= 0; i--) {
          this.diagnostics.push( new DiagnosticModel(response._embedded.diagnostic[i]) );
        }
        this.showedDiagnostics = this.diagnostics;
        setTimeout(()=>{ this.snackBar.dismiss(); }, 0);
        this.isLoading = false;
      }) );
  }


  newDiagnostic() {
    let questionnaryMemberOf = this.apiService.createParams({
      BuildingType: this.building.BuildingType.id,
      society: this.apiService.connectedUser.society_id
    });

    this.apiService.getFromServer('questionnary', questionnaryMemberOf)
        .then(s => s.subscribe((response:any) => {
          let list = [];
          for( let q in response._embedded.questionnary) {
            let item = response._embedded.questionnary[q];
            list[item.id] = item.name.replace('Questionnaire','Audit');
          }

          this.dialogService.autocomplete("Choisir l'audit", list)
            .subscribe(questionnary_id => {
              if(questionnary_id != undefined) {
                this.createNewDiagnostic(this.building.id, questionnary_id)
                  .then((newDiagnostic)=>{ this.editDiagnostic(newDiagnostic) });
              }
              });
        }) );
  }

  createNewDiagnostic(building_id:number, questionnary_id:number): Promise<DiagnosticModel>
  {
    let date = new Date();
    let diagnosticPromise: Promise<DiagnosticModel> = new Promise( (resolve, reject) => {
      let newDiagnostic = {
        building: building_id,
        questionnary: questionnary_id,
        date: date.toLocaleDateString(),
        ratio: 0,
        finished: 0,
        trash: 0
      }
      this.apiService.SaveToServer('diagnostic', newDiagnostic)
          .then(s => s.subscribe((response:any) => {
             resolve( new DiagnosticModel(response) );
          }) );
    });

    return diagnosticPromise;
  }

  editDiagnostic(diagnostic:DiagnosticModel)
  {
    this.router.navigate(['questionnary/'+diagnostic.id]);
  }

  duplicDiagnostic(diagnostic:DiagnosticModel)
  {
    let date = new Date();
    let cloneDiagnosticParams = {
      building: diagnostic.building.id,
      clone: diagnostic.id,
      date: date.toLocaleDateString(),
    };
    this.apiService.SaveToServer('diagnostic', cloneDiagnosticParams)
          .then(s => s.subscribe((response:any) => {
             let clonedDiagnostic = new DiagnosticModel(response);
             this.editDiagnostic(clonedDiagnostic);
          }) );
  }

  completeThenEditDiagnostic(diagnostic:DiagnosticModel)
  {
    this.apiService.UpdateToServer('diagnostic', {
            id: diagnostic.id, complete_diagnostic: true})
        .then(s => s.subscribe((response:any) => {
          this.editDiagnostic(diagnostic);
        }) );
  }


  deleteDiagnostic(index:number)
  {
    this.dialogService.confirm('audit-list-delete-confirm-message')
        .subscribe(res => {
          if(res) this.apiService.DeleteFromServer('diagnostic', this.diagnostics[index])
            .then(s => s.subscribe(
              response => {
                this.diagnostics.splice(index, 1);
              },
              err => {
                console.log('erreur', err);
                this.dialogService.alert('Impossible de supprimer : ');
              }
            ) );
        });
  }



  gotoReport(diagnostic:DiagnosticModel)
  {
    this.gd.current = diagnostic;
    this.router.navigate(['report/'+diagnostic.id]);
  }
  gotoMDR(diagnostic:DiagnosticModel)
  {
    this.gd.current = diagnostic;
    this.router.navigate(['rm/generator/'+diagnostic.id]);
  }

  getColor(note)
  {
    if(note==undefined) return '#CCCCCC';
    if(note<6) return Colors.colors[0];
    else if (note<=10) return  Colors.colors[1];
    else if (note<=14) return Colors.colors[2];
    else return Colors.colors[3];
  }


  get filterList()
  {
    let labels = [];
    this.diagnostics.forEach((diagnostic)=>{
      if(!labels.includes(diagnostic.auditName))
        labels.push(diagnostic.auditName);
    });
    return labels;
  }

  filterDiagnosticsBy(filterName=null)
  {
    if(!filterName)
      this.showedDiagnostics = this.diagnostics;
    else
      this.showedDiagnostics = this.diagnostics.filter((diagnostic)=>{
        return filterName==diagnostic.auditName;
      });
  }


}
